export default __webpack_public_path__ + "static/media/guiaIphone4.7632c43a.png";